import { define, memberOf, type, auto } from 'type-r';
import Collection, {Record} from './base'
import ProductVariable, {ProductVariableCollection} from './product_variable'

@define
export class MenuItemSlotCollection<R extends MenuItemSlot = MenuItemSlot> extends Collection<R> {
    static comparator = 'order'
}

@define
export default class MenuItemSlot extends Record {
    static idAttribute = "pid";
    static Collection = MenuItemSlotCollection
    @type(String).value("").as pid: string
    @type(String).value("").as section: string
    @type(String).value("").as title: string
    @type(ProductVariableCollection).as variables: ProductVariableCollection
    @type(Boolean).value(false).as modded: boolean
    @type(String).as selectedVariable: string
    @type(Number).as order: number
    
    set selected(v:ProductVariable|string|number) {
        if (typeof v == 'string' || typeof v == 'number') {
            var mdl:ProductVariable = this.variables.get(v.toString());
            if (mdl)
                this.selectedVariable = mdl.pid.toString();
            else
                this.selectedVariable = null;
        }
        else {
            this.selectedVariable = v.pid.toString();
        }
    }
    
    get selected():ProductVariable {
        return this.selectedVariable ? this.variables.get(this.selectedVariable) : null;
    }
    
    get defprod() {
	return this.variables.find(function(v) {
	    return v.default;
	});
    }
    
    initialize(atts?:any, opts?:any) {
        super.initialize(atts, opts);
        this.on("change:selectedVariable", () => this.chooseProduct());
	this.variables.each(v => v.on("choose_product", () => this.chooseProduct()));
    }

    validate() {
        if (this.variables.length && !this.selectedVariable)
            return {obj: this, message: 'Item not selected'};
        else if (this.selected) {
            if (this.selected.variants && this.selected.variants.length && !this.selected.selected) {
                return {obj: this, message: `Option not selected for ${this.selected.title}`};
            }
        }
        else return;
    }
    
    chooseProduct() {
        var args = [this.selected && this.selected.selected ? this.selected.selected.pid : (this.selected ? this.selected.pid : null), this.pid];
        console.log("Choose Product",args);
	jQuery(document.body).trigger("choose_product", args);
    }
    
    toJSON(opts?:any) {
	var data = super.toJSON(opts);
	data.selected = this.selected ? this.selected.toJSON() : undefined;
	data.defprod = this.defprod ? this.defprod.toJSON() : undefined;
	return data;
    }
    
    toData() {
	var chosen:string = "";
	if (this.selected) {
	    if (this.selected.selected)
		chosen = this.selected.selected.pid;
	    else if (this.selected.defprod)
		chosen = this.selected.defprod.pid;
	}
	else if (this.defprod) {
	    if (this.defprod.defprod)
		chosen = this.defprod.defprod.pid;
	}
	
	var d = {id: this.id, value: chosen ? chosen : ""};
	return d;
    }
}
